import { memo } from 'react';
import { UserAvatar } from 'shared/user_avatar/UserAvatar';
import styled from 'styled-components';
import { title } from 'styles/theme';

const Container = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-areas: 'avatar user';
    column-gap: 0.8rem;
    align-items: center;
    padding: 1rem;
`;

const Avatar = styled(UserAvatar)`
    grid-area: avatar;
`;

const User = styled.div`
    grid-area: user;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    word-break: break-all;
    gap: 0.25rem;
`;

const Name = styled.div`
    display: flex;
    align-items: center;
    gap: 0.3rem;
    color: ${title};
    font-size: 1.4rem;
`;

export type CmmsDetailsProps = Readonly<{
    cmmsName: string;
    className?: string;
}>;

function CmmsDetails({ cmmsName, className }: CmmsDetailsProps) {
    return (
        <Container key={cmmsName} aria-label={cmmsName} className={className}>
            <Avatar
                firstName={cmmsName}
                lastName={undefined}
                isCmms
                size="3.2rem"
                fontSize="1.2rem"
            />
            <User>
                <Name>{cmmsName}</Name>
            </User>
        </Container>
    );
}

const memoCmmsDetails = memo(CmmsDetails);
export { memoCmmsDetails as CmmsDetails };
